export default {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  BIWEEKLY: 'biWeekly',
};
